(function() {
  'use strict';
  
  angular
    .module('plugins.multiple-choice')
    .controller('MultipleChoiceResultHiddenController', MultipleChoiceResultHiddenController);
  
  MultipleChoiceResultHiddenController.$inject = [
    '$log', 
    '$scope',
    'pollPluginService'
  ];
    
  function MultipleChoiceResultHiddenController(
      $log, 
      $scope,
      pollPluginService
    ) {
    $log = $log.getInstance('MultipleChoiceResultHiddenController');
    
    /* jshint validthis: true */
    var vm = this;
    
    vm.choices = {};
    vm.numberOfResponders = 0;
    
    var respondersTable = {}

    activate();

    function activate() {
      var poll = $scope.poll
        , result = $scope.result;

      // Create data object for hashtable
      result.data = {}; 
      result.data['multiple-choice'] = _.map(
        poll.data.choices, 
        function(choice) {
          return {
            label: choice.label,
            text: choice.text,
            value: 1
          }
        }
      );

      // Run through previous responses
      _.each(result.responses, function(response) { updateTable(response) })
      
      pollPluginService.onResponseReceived($scope, result._id, _onResponseReceived);
    }

    function updateTable(response) {
      respondersTable[response.user] = true;
      vm.numberOfResponders = Object.keys(respondersTable).length;
    }

    function _onResponseReceived(response) {
      $scope.result.responses.push(response)
      updateTable(response)
    }

  }
  
})();